import type { CreateAssetScopedCustomFieldValueRequestDto } from '@evimo/types/api/asset-custom-field-value/create-asset-custom-field-value/create-asset-scoped-custom-field-value.request.dto';
import type { CreateAssetCustomFieldValueResponseDto } from '@evimo/types/api/asset-custom-field-value/create-asset-custom-field-value/create-asset-custom-field-value.response.dto';
import type { FindAssetCustomFieldValueResponseDto } from '@evimo/types/api/asset-custom-field-value/find-asset-custom-field-value/find-asset-custom-field-value.response.dto';
import type { UpdateAssetCustomFieldValueRequestDto } from '@evimo/types/api/asset-custom-field-value/update-asset-custom-field-value/update-asset-custom-field-value.request.dto';
import { ResponseError } from '@evimo/client/runtime';
import {
  assetCustomFieldValuesApi,
  assetCustomFieldValueRequestInit,
} from '~/app/services/asset-custom-field-value/asset-custom-field-value-api-instances';

async function readClientError(error: unknown): Promise<never> {
  if (error instanceof ResponseError) {
    const message = await error.response.text();
    throw new Error(message || `Request failed (${error.response.status})`);
  }
  throw error;
}

export const AssetCustomFieldValueService = {
  async findByAsset(
    organizationId: string,
    assetId: string,
  ): Promise<FindAssetCustomFieldValueResponseDto[]> {
    try {
      return await assetCustomFieldValuesApi.assetCustomFieldValuesByAssetControllerGetByAsset(
        { organizationId, assetId },
        assetCustomFieldValueRequestInit,
      );
    } catch (error) {
      return readClientError(error);
    }
  },

  async create(
    organizationId: string,
    assetId: string,
    dto: CreateAssetScopedCustomFieldValueRequestDto,
  ): Promise<CreateAssetCustomFieldValueResponseDto> {
    try {
      return await assetCustomFieldValuesApi.assetCustomFieldValuesByAssetControllerCreate(
        {
          organizationId,
          assetId,
          createAssetScopedCustomFieldValueRequestDto: dto,
        },
        assetCustomFieldValueRequestInit,
      );
    } catch (error) {
      return readClientError(error);
    }
  },

  async update(
    organizationId: string,
    assetId: string,
    id: string,
    dto: UpdateAssetCustomFieldValueRequestDto,
  ): Promise<FindAssetCustomFieldValueResponseDto> {
    try {
      return await assetCustomFieldValuesApi.assetCustomFieldValuesByAssetControllerUpdate(
        {
          organizationId,
          assetId,
          valueId: id,
          updateAssetCustomFieldValueRequestDto: dto,
        },
        assetCustomFieldValueRequestInit,
      );
    } catch (error) {
      return readClientError(error);
    }
  },

  async delete(
    organizationId: string,
    assetId: string,
    id: string,
  ): Promise<void> {
    try {
      await assetCustomFieldValuesApi.assetCustomFieldValuesByAssetControllerDelete(
        {
          organizationId,
          assetId,
          valueId: id,
        },
        assetCustomFieldValueRequestInit,
      );
    } catch (error) {
      return readClientError(error);
    }
  },
};
